import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import NewButton from '../../common/components/NewButton';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

const List = ({ allowNew, t, ...rest }) => {
	const columns = [
		{
			header: t('Franchisee_Name'),
			accessor: 'name',
			sortable: true
		},
		{
			header: t('Franchisee_ContactPerson'),
			accessor: 'contactPerson',
			sortable: true
		},
		{
			header: t('Franchisee_CompanyNumber'),
			accessor: 'companyNumber',
			sortable: true
		},
		{
			header: t('Franchisee_IsOnline'),
			accessor: 'isOnline',
			sortable: true,
			cell: (isOnline) => (ui.formatBoolean(isOnline))
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id) => (<Link to={`/franchisees/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={faEdit} /> {t('Common_Edit')}</Link>)
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} listActions={allowNew && <NewButton newItemPath='/franchisees/new' />} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);